/**
 * The strings of the malware scanner's screens (piece 9; decisions 1180 to
 * 1182), kept beside the rules they draw so the one lookup stays one table.
 * 🔨 Every message is a sentence; every pill is Title Case.
 */
export const QUARANTINE_STRINGS = {
  'scanner.title': 'Malware Scanner',
  'scanner.hint': 'Every uploaded file is checked for viruses before anybody can open it. Enter the address of your virus scanner here; with none saved, the server’s own default is used, and with neither a stand-in passes every file except the standard test file.',
  'scanner.address': 'Scanner address',
  'scanner.addressHint': 'A host name with an optional port, such as clamav:3310.',
  'scanner.check': 'Check the Scanner',
  'scanner.checking': 'The scanner is being asked for its answer.',
  'scanner.step.warn': 'Choose when to warn',
  'scanner.step.warnSummary': 'The nightly run asks the scanner how it is and warns the super admins in their feed when it is silent or its signatures are old.',
  'scanner.quietHours': 'Hours without an answer before a warning',
  'scanner.quietHoursHint': 'The nightly run warns when the scanner has not answered a scan or a check for this long. One hour unless set.',
  'scanner.maxAgeDays': 'Days the signatures may age before a warning',
  'scanner.maxAgeDaysHint': 'ClamAV updates its signatures once a day by itself. Older than this, the nightly run warns and the Status row turns amber. Three days unless set.',
  'quarantine.title': 'Quarantined Files',
  'quarantine.hint': 'Every file the malware scan blocked is held here for thirty days and then deleted for good. Nobody can open a quarantined file. A super admin can release one with a written reason, which marks it clean without scanning it again.',
  'quarantine.empty': 'No file is quarantined.',
  'quarantine.uploadedBy': 'Uploaded by',
  'quarantine.on': 'on',
  'quarantine.noRecord': 'no record',
  'quarantine.blockedOn': 'Blocked',
  'quarantine.signature': 'Signature',
  'quarantine.noSignature': 'not named',
  'quarantine.daysLeft': 'Days before deletion:',
  'quarantine.release': 'Release',
  'quarantine.releaseTitle': 'Release a Quarantined File',
  'quarantine.releaseWarning': 'Releasing marks this file clean without scanning it again, so anybody who can open its record can download it. Release it only if you know the scanner was wrong.',
  'quarantine.reason': 'Why is this file safe?',
  'quarantine.released': 'The file was released and can be opened again.',
  'quarantine.extensionHeld': 'This file was held for its name, so it is never released here.',
  'quarantine.superAdminOnly': 'Only a super admin can release a quarantined file.',
  'quarantine.pill': 'Quarantined',
} as const;
